var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Index, JoinColumn, ManyToOne, PrimaryColumn, UpdateDateColumn } from 'typeorm';
import { Project } from './project.js';
import { VantagePoint } from './vantage-point.js';
export class BaseSnapshot {
    id;
    createdDate;
    updatedDate;
    count;
    error;
    project;
    projectId;
    node;
    job;
    tags;
    analyzed;
}
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], BaseSnapshot.prototype, "id", void 0);
__decorate([
    Index(),
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], BaseSnapshot.prototype, "createdDate", void 0);
__decorate([
    Index(),
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], BaseSnapshot.prototype, "updatedDate", void 0);
__decorate([
    Column({ default: 1 }),
    __metadata("design:type", Number)
], BaseSnapshot.prototype, "count", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BaseSnapshot.prototype, "error", void 0);
__decorate([
    Index(),
    ManyToOne(() => Project, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'projectId' }),
    __metadata("design:type", Project)
], BaseSnapshot.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], BaseSnapshot.prototype, "projectId", void 0);
__decorate([
    Index(),
    ManyToOne(() => VantagePoint, { nullable: true }),
    __metadata("design:type", VantagePoint)
], BaseSnapshot.prototype, "node", void 0);
__decorate([
    Column('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], BaseSnapshot.prototype, "job", void 0);
__decorate([
    Column('text', { array: true, default: () => 'ARRAY[]::text[]' }),
    __metadata("design:type", Array)
], BaseSnapshot.prototype, "tags", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], BaseSnapshot.prototype, "analyzed", void 0);
//# sourceMappingURL=data:application/json;base64,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